


import Vue from 'vue'
import axios from './configs/axios'
import store from './store'
import router from './router'
import './configs/apps'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import App from './App.vue'
import infiniteScroll from 'vue-infinite-scroll'

Vue.directive('transfer-dom', TransferDom)
Vue.config.productionTip = false

Vue.use(LoadingPlugin)
Vue.use(ToastPlugin)
Vue.use(ConfirmPlugin)
Vue.use(axios)
Vue.$message = Vue.prototype.$message = function (option) {
let t = option.type
this.$vux.toast.show({
text: option.message, type: t === 'error' ? 'cancel' : (t === 'info' ? 'text' : t), time: 3000
})
}
Vue.use(infiniteScroll)
/* eslint-disable no-new */

import ContentType from 'vue-django/src/components/generic/ContentType'
ContentType.loadIdMap()

import './router/permission'
import {userOnlineTimeCounter} from 'vue-django/src/utils/dailylog'
userOnlineTimeCounter((data) => {
store.state.bus.$emit('user_online_timer', data)
})
import './styles.css'
new Vue({
el: '#app-box',
router,
store,
render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js